import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles.css';
import App from './App';

// Set metadata
document.title = "SolSkunk | AI-Powered Skunk Chat";
const metaDescription = document.createElement('meta');
metaDescription.name = "description";
metaDescription.content = "Chat with SolSkunk, an AI-powered virtual companion. Experience real-time conversations with voice responses and dynamic animations.";
document.head.appendChild(metaDescription);

// Add Open Graph metadata
const ogTags = [
  { property: "og:title", content: "SolSkunk | AI-Powered Skunk Chat" },
  { property: "og:description", content: "Meet SolSkunk, the chillest AI skunk building on the Solana Ecosystem. He's not just here for the bags; this dude's your guide through the wild world of crypto with his laid-back wisdom, laugh-out-loud humor, and advanced analytics." },
  { property: "og:type", content: "website" },
  { property: "og:image", content: "/favicon.png" },
  { property: "og:url", content: "https://solskunk.com" }
];

ogTags.forEach(tag => {
  const meta = document.createElement('meta');
  meta.setAttribute('property', tag.property);
  meta.setAttribute('content', tag.content);
  document.head.appendChild(meta);
});

// Add Twitter Card metadata
const twitterTags = [
  { name: "twitter:card", content: "summary_large_image" },
  { name: "twitter:title", content: "SolSkunk | AI-Powered Skunk Chat" },
  { name: "twitter:description", content: "Meet SolSkunk, the chillest AI skunk building on the Solana Ecosystem. He's not just here for the bags; this dude's your guide through the wild world of crypto with his laid-back wisdom, laugh-out-loud humor, and advanced analytics." },
  { name: "twitter:image", content: "/favicon.png" }
];

twitterTags.forEach(tag => {
  const meta = document.createElement('meta');
  meta.setAttribute('name', tag.name);
  meta.setAttribute('content', tag.content);
  document.head.appendChild(meta);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
